import { Component, OnInit, ViewChild } from '@angular/core';
import { GrupoEquipamento } from 'src/app/classes/GrupoEquipamento';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { GrupoEquipamentoService } from 'src/app/services/grupo-equipamento.service';
import Swal from 'sweetalert2';
import { UtilsService } from 'src/app/utils/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { ColumnModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { FormsGrupoEquipamentoComponent } from './forms-grupo-equipamento/forms-grupo-equipamento.component';
import { finalize } from 'rxjs/operators';
import moment from 'moment';

@Component({
  selector: 'app-grupo-equipamento',
  templateUrl: './grupo-equipamento.component.html',
  styleUrls: ['./grupo-equipamento.component.scss']
})
export class GrupoEquipamentoComponent implements OnInit {
  @ViewChild('gridGruposEquipamento', { static: false })
  gridGruposEquipamento: SyncGridComponent;

  @ViewChild("FormsGrupoEquipamento", { static: false })
  FormsGrupoEquipamento: FormsGrupoEquipamentoComponent;

  gruposEquipamento: GrupoEquipamento[];
  auxGruposEquipamento: GrupoEquipamento[];
  grupoEquipamento: GrupoEquipamento;
  id: number;
  inserindo: boolean = false;
  carregando: boolean = false;
  isSuper: boolean = false;
  public isSubmit: boolean;
  textoBusca: string = "";
  perfilLogado: number = 0;
  gruposEquipamentoColumns: ColumnModel[] = [];
  gridPageSettings: PageSettingsModel = {
    pageSizes: [10, 20, 50],
    pageSize: 20, // padrão alterado para 20
    pageCount: 4
  };
  gridHeight: string = '79vh';
  desabilitarAcoes: boolean = false;
  removendo: boolean = false;
  inativando: boolean = false;
  duplicando: boolean = false;

  FEITO: string = "Feito!";
  ERRO: string = "Erro!";
  CANCELAR: string = "Cancelar";
  SIM: string = "Sim";
  CONFIRMAR_DELETE: string = "Se deletar, esta ação não poderá ser desfeita!";
  DELETAR_PARAM: string;
  GRUPO_DELETADO: string = "Grupo de produtos deletada!";
  GRUPO_CADASTRADA: string = "Grupo de produto cadastrada!";
  GRUPO_ALTERADO: string = "Grupo de produto alterada!";
  constructor(private gruposEquipamentoService: GrupoEquipamentoService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private utils: UtilsService,
    private translate: TranslateService,
    private location: Location) {
    if (this.router.url.search("inserir") > 0) {
      if (!this.utils.verificarPermissaoUsuario('IncluirGrupoEquipamento')) {
        this.location.back();
      }
    }
    this.route.params.subscribe(res => {
      this.id = res.id;
      if (this.id > 0)
        if (!this.utils.verificarPermissaoUsuario('EditarGrupoEquipamento')) {
          this.location.back();
        }
    });
  }


  configurarTraducao() {
    this.FEITO = this.translate.instant('FEITO');
    this.GRUPO_ALTERADO = this.translate.instant('GRUPO_DE_EQUIPAMENTO_ALTERADO');
    this.GRUPO_CADASTRADA = this.translate.instant('GRUPO_DE_EQUIPAMENTO_CADASTRADO');
    this.GRUPO_DELETADO = this.translate.instant('DELETAR');
    this.CONFIRMAR_DELETE = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.SIM = this.translate.instant('SIM');
    this.GRUPO_DELETADO = this.translate.instant('GRUPO_DE_EQUIPAMENTO_DELETADO');
  }

  ngOnInit() {
    var usuarioLogado = this.storageService.getUsuario();
    this.isSuper = usuarioLogado.isSuper;
    this.perfilLogado = usuarioLogado.Perfil;
    this.grupoEquipamento = new GrupoEquipamento();
    this.listar();
    this.prepararGrid()
  }


  prepararGrid(): void {
    this.gruposEquipamentoColumns = [
      { type: "checkbox", width: 50 },
      {
        field: "Descricao",
        headerText: "Descrição",
        allowSorting: true,
        width: "100%"
      },
      {
        field: "dataAlteracaoStr",
        type: "string",
        headerText: "Ult. Mod.",
        allowSorting: true,
        sortComparer: (a: string, b: string) => {
          return moment(a, 'DD/MM/YYYY HH:mm').diff(moment(b, 'DD/MM/YYYY HH:mm'));
        }
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "AtivoDesc",
        headerText: "Status",
        type: "boolean",
        allowSorting: true,
        disableHtmlEncode: false,
        filter: {
          type: 'Menu'
        },
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatus(_data.Ativo);
        }
      }
    ];
    this.ajustarTamanhoGrid();
  }

  doubleClick(event): void {
    this.editar(event)
  }

  badgeStatus(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }

  ajustarTamanhoGrid(): void {
    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement;
      const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement;
      const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement;
      const title = document.querySelector('app-grupo-equipamento h5.titulo') as HTMLElement;
      const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement;

      if (!navbar || !toolbar || !title) return;

      const groupdropareaHeight = groupdroparea ? groupdroparea.offsetHeight : 0;
      const pagerHeight = pager ? pager.offsetHeight : 0;

      const altura = window.innerHeight - navbar.offsetHeight - groupdropareaHeight - toolbar.offsetHeight - title.offsetHeight - pagerHeight - 70;
      this.gridHeight = `${altura}px`;
    }, 100);
  }


  selecionarGrupoEquipamento() {
    this.carregando = true;
    this.gruposEquipamentoService.getGrupoEquipamento(this.id).subscribe(res => {
      this.grupoEquipamento = new GrupoEquipamento();
      this.grupoEquipamento = res;
      this.carregando = false;
    },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      })
  }

  listar() {
    this.ERRO = this.translate.instant("ERRO");
    this.carregando = true;
    this.gruposEquipamentoService.getTodosGrupoEquipamentos()
      .pipe(
        finalize(() => {
          this.carregando = false;
        })
      )
      .subscribe(
        (res: GrupoEquipamento[]) => {

          this.gruposEquipamento = res.map(u => Object.assign(new GrupoEquipamento(), u));;
          if (!this.inserindo)
            this.auxGruposEquipamento = res;
          if (this.textoBusca != '')
            this.filtrar();
        },
        err => {
          this.utils.getErro(err);
        })
  }

  novo(): void {
    if (!this.utils.verificarPermissaoUsuario('IncluirGrupoEquipamento'))
      return;
    this.FormsGrupoEquipamento.abrirModal();
  }

  editar(entidade: GrupoEquipamento): void {
    let grupo;
    if (!entidade) {
      var grupos = this.gridGruposEquipamento.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return;

      grupo = { ...grupos[0] };
    }
    else
      grupo = { ...entidade }
    this.FormsGrupoEquipamento.abrirModal(grupo);
  }

  ValidarSelectApenasUm(): boolean {
    var variedades = this.gridGruposEquipamento.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (variedades.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var variedades = this.gridGruposEquipamento.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  selecionar() {
    this.ERRO = this.translate.instant("ERRO");

    this.carregando = true;
    this.gruposEquipamentoService.getGrupoEquipamento(this.id).subscribe(res => {
      this.grupoEquipamento = new GrupoEquipamento();
      this.grupoEquipamento = res;
      this.change();
      this.carregando = false;
    },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      })
  }

  confirmaDuplicar(): void {
    var variedades = this.gridGruposEquipamento.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os grupos de equipamentos selecionados serão duplicadas!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar grupo de equipamentos",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(variedades);
      }
    });
  }

  duplicar(grupos: GrupoEquipamento[]): void {
    this.duplicando = true
    this.gruposEquipamentoService.duplicar(grupos.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess("Grupos de equipamentos duplicados com sucesso")
        this.listar();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }


  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais) return
    var lista = this.gridGruposEquipamento.getSelectedRecords();
    if (lista.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    const todasInativas = lista.every(v => v.Ativo === false);
    const algumaInativa = lista.some(v => v.Ativo === false);

    if (todasInativas) {
      this.utils.handleWarning("Todos os grupos de equipamentos selecionados já estão inativos");
      return;
    }

    let texto = "Os os grupos de equipamentos selecionados serão inativados!";
    if (algumaInativa) {
      texto += '<br> Alguns grupos de equipamentos já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar grupos de equipamentos",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(lista);
      }
    });

  }

  inativar(lista: GrupoEquipamento[]): void {
    this.inativando = true
    this.gruposEquipamentoService.inativar(lista.map(p => p.Id))
      .subscribe((res) => {
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const item = lista.find(v => v.Id.toString() === id);
            const nomeItem = item ? item.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeItem}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao Inativar Grupos de Equipamentos',
            html: `Os seguintes grupos de equipamentos não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } if (lista.filter(v => v.Ativo === false).length > 0) {
          const erros: string[] = [];
          lista.filter(v => v.Ativo === false).forEach(item => {
            const nomeItem = item ? item.Descricao : `ID ${item.Id}`;
            erros.push(`<b>${nomeItem}</b>: Já está inativo.`);
          });
          Swal.fire({
            title: 'Erro ao Inativar Grupos de Equipamentos',
            html: `os seguintes grupos de equipamentos não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        }
        else {
          this.utils.handleSuccess("Grupos de Equipamentos inativados com sucesso");
        }
        this.listar();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }

  finalizarSave(): void {
    this.listar();
  }

  confirmRemover() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirVariedade'))
      return;

    this.ERRO = this.translate.instant("ERRO");
    this.FEITO = this.translate.instant("FEITO");
    this.CONFIRMAR_DELETE = this.translate.instant("CONFIRMAR_DELETE");
    this.CANCELAR = this.translate.instant("CANCELAR");
    this.SIM = this.translate.instant("SIM");
    this.GRUPO_DELETADO = this.translate.instant("GRUPO_DELETADO");

    var lista = this.gridGruposEquipamento.getSelectedRecords();
    if (lista.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os grupos de equipamentos selecionados serão excluidos, esta ação não poderá ser desfeita!",
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.remover(lista)
    });
  }

  remover(lista: GrupoEquipamento[]) {
    this.removendo = true;
    this.gruposEquipamentoService.deleteLista(lista.map(p => p.Id)).subscribe(
      res => {
        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais variedades falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const variedade = lista.find(v => v.Id.toString() === id);
            const nomeVariedade = variedade ? variedade.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeVariedade}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir grupo de equipamentos',
            html: `Os seguintes grupo de equipamentos não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          this.utils.handleSuccess("Grupo de equipamentos excluídas com sucesso");
        }

        this.listar();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });

  }

  filtrar() {
    this.gruposEquipamento = this.auxGruposEquipamento.filter(x =>
      x.Descricao.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
    );
  }

  cancelar() {
    this.router.navigate(['/cadastros/grupo-equipamento']);
  }

  get(id: number): GrupoEquipamento {
    if (!this.gruposEquipamento || this.gruposEquipamento.length === 0)
      return null;

    let grupo = this.gruposEquipamento.filter(x =>
      x.Id == id
    );

    return grupo.length > 0 ? grupo[0] : new GrupoEquipamento();
  }

  change(abrindoModal: boolean = false) {
    if (abrindoModal)
      return;
  }
}
